<template>
  <div v-if="reviews.length > 0">
    <div class="row mb-3">
      <div class="col">
        <h2>Értékelések</h2>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-4 d-flex" v-for="(review, index) in reviews">
        <div class="card mb-4 h-100">
          <div class="card-body">
            <div class="review-stars mb-3">
              <i v-for="index in review.rating" class="fas fa-star c-yellow"></i>
              <i v-for="index in (5 - review.rating)" class="far fa-star c-yellow"></i>
            </div>
            <p class="card-text">{{ review.text }}</p>
            <p class="card-text"><b>{{ review.author_name }}</b></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';

@Component
export default class GoogleReviews extends Vue {

  @Prop(Array) reviews;

}
</script>
<style>
.c-yellow {
  color: #ffb500;
}
</style>